import { lazy, Suspense, useContext } from "react";
import { useLocation } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import { AuthRoutes } from "./AuthRoutes";
import { AppRoutes } from "./AppRoutes";
import { AuthContext } from "../contexts/AuthContext";

const ScoreboardPublicAdmin = lazy(() => import("../views/LiveStreams/ScoreboardPublicAdmin"));

export function Routes() {
  const { authInfo, isAuthResolved } = useContext(AuthContext);
  const location = useLocation();
  const isPublicScoreboardOperatorRoute = /^\/transmissoes\/placar\/admin\/[^/]+/i.test(
    location.pathname
  );

  if (isPublicScoreboardOperatorRoute) {
    return (
      <Suspense
        fallback={
          <Box
            sx={{
              minHeight: "100vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CircularProgress size={28} />
          </Box>
        }
      >
        <ScoreboardPublicAdmin />
      </Suspense>
    );
  }

  if (!isAuthResolved) {
    return (
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress size={28} />
      </Box>
    );
  }

  return (
    <>
      {authInfo ? (
        <AppRoutes />
      ) : (
        <AuthRoutes />
      )}
    </>
  );
}
